import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Forces window scroll to top on every route change.
 *
 * Mounted once inside <BrowserRouter /> in App.js. Uses a double-fire
 * (synchronous + rAF) so we beat both layout effects and the browser's
 * native scroll-restoration on slow clients. Respects in-page anchors
 * (when `hash` is present, we let the browser handle the jump).
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // browser handles anchor scrolling
    // Synchronous reset for fast clients
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    // rAF reset catches the post-mount layout shift
    const raf = window.requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
    return () => window.cancelAnimationFrame(raf);
  }, [pathname, hash]);

  return null;
}
